import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"
import { COLORS } from "./PlotGraph"
import { BatteryData } from "../services/adminService"
import { tutToDate } from "../util"



const BatteryStatusChart = ({ graphData }: { graphData: BatteryData }) => {
    let graphlabel = { value: `Battery Percentage`, angle: -90, position: "insideBottomLeft" }
    let domainThresholds: number[] = [-5, 105] // Y axis limits for plot
    let ticks: number[] = [0, 25, 50, 75, 100] // Y axis ticks for plot

    let graphableData = graphData.points.map((point, _index, _array) => {
        return {
            date: tutToDate(Number(point.timestamp)),
            batteryPercentage: point.batteryLevel
        }
    });


    return (
        <ResponsiveContainer width="100%" height={400} style={{ paddingBottom: "5rem" }}>
            <LineChart
                data={graphableData}
                margin={{
                    top: 0,
                    right: 10,
                    left: 10,
                    bottom: 0
                }}>
                <CartesianGrid strokeDasharray="5 5 " opacity={0.2} />
                <XAxis
                    dataKey="date"
                    type="category"
                    interval="preserveStartEnd" // Ensures fewer, evenly spaced ticks
                    minTickGap={80} // Increase spacing between ticks
                    tickFormatter={(date: Date) =>
                        date.toLocaleString(undefined, {
                            month: "short",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                        })
                    }
                    label={{ value: "Time", position: "insideBottomLeft", offset: -5 }}
                />
                <YAxis
                    domain={domainThresholds}
                    label={graphlabel}
                    ticks={ticks}
                    tickFormatter={(value) =>
                        Number.isInteger(value) ? value : value.toFixed(2)
                    }
                />
                <Line
                    type="monotone"
                    dataKey="batteryPercentage"
                    name="Battery Percentage"
                    stroke={`${COLORS[1]}`}
                    activeDot={{ r: 8 }}
                    strokeWidth={4}
                    dot={false}
                />
                <Legend />

                <Tooltip
                    labelFormatter={(label: Date) =>
                        label.toLocaleString(undefined, {
                            month: "short",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: false,
                        })
                    }
                />
            </LineChart>
        </ResponsiveContainer>
    )
}

export default BatteryStatusChart;